import { render } from "./NcrmWorkflowDataEnrichmentSettings.vue?vue&type=template&id=2fb39e78"
import script from "./NcrmWorkflowDataEnrichmentSettings.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowDataEnrichmentSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__